import { t_bgImageMode } from './Canvas';

export const SITE_NAME = '文章を画像に変換するツール';

export const STORAGE_KEY_TEXT = 'text';
export const STORAGE_KEY_BGURL = 'bgUrl';
export type t_storageKeys = typeof STORAGE_KEY_TEXT | typeof STORAGE_KEY_BGURL;

export const IMGUR_UPLOAD_FAILED = 'F';
export const IMGUR_UPLOAD_REQUESTING = 'L';

export const SCREEN_NAMES = {
	home: '/',
	edit: '/edit',
};

export const PROMOTION =
	'https://github.com/somosomosomosan/texttoimage で作成しました';

export const COMMANDS = {
	mido: 'https://i.imgur.com/cNvWq7Z.png',
	mmido: 'https://i.imgur.com/CXD4nFt.png',
	smido: 'https://i.imgur.com/QTTayOv.png',
	rmido: 'https://i.imgur.com/Pm2C2Ck.png',
	drug: 'https://i.imgur.com/8tiCgn2.png',
	adrug: 'https://i.imgur.com/UZslZDW.png',
	mdrug: 'https://i.imgur.com/QwIC8M8.png',
	virus: 'https://i.imgur.com/svb7J6M.png',
	yvirus: 'https://i.imgur.com/Tdc10gI.png',
};

export const COMMANDSHINT =
	'URL入力補助コマンド: drug, mdrug, virus, yvirus, mido, rmido, mmido, smido';

export const EXPORTED_FILE_NAME = 'canvas';

export const DEFAULT_STAGE_MAX_WIDTH = 530;
export const DEFAULT_FONT_SIZE = 24;

export const FONT_FAMILIES = [
	[
		'Hiragino Kaku Gothic ProN',
		'ヒラギノ角ゴ ProN W3',
		'ヒラギノ角ゴシック',
		'Hiragino Sans',
	],
	['ヒラギノ丸ゴ ProN', 'Hiragino Maru Gothic ProN'],
	['コーポレート・ロゴ ver2', 'Corporate Logo'],
	['UD デジタル 教科書体 N-B'],
	['UD デジタル 教科書体 N-R'],
	['メイリオ', 'Meiryo'],
	['Meiryo UI'],
	['MS UI Gothic'],
	['Yu Gothic', 'YuGothic'],
	['ＭＳ ゴシック'],
	['F910新コミック体'],
	[
		'Noto Sans CJK JP',
		'Noto Sans JP',
		'NotoSansJapanese-Regular',
		'Keyocera Noto Sans Japanese',
	],
	['-apple-system'],
	['BlinkMacSystemFont'],
	['Arial'],
	['Osaka-Mono'],
	['Segoe UI'],
	['Roboto'],
	['Oxygen'],
	['Ubuntu'],
	['Cantarell'],
	['Fira Sans'],
	['Droid Sans', 'DroidSans'],
	['Helvetica Neue'],
	//	['sans-serif body'],
	['serif'],
	['sans-serif'],
];

export const FONT_SIZE_LIST = [
	7, 8, 9, 10, 10.5, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25,
	26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44,
	45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60,
];

export const FONT_COLORS = [
	'#000000',
	'#666666',
	'#B3B3B3',
	'#FFF',
	'#9F0500',
	'#C45100',
	'#FB9E00',
	'#808900',
	'#194D33',
	//'#0C797D',
	'#0062B1',
	'#653294',
	'#AB149E',
	//'transparent',
];
/*
export const FONT_COLORS = [
	'#000000',
	'#FFFFFF',
	'#B80000',
	'#DB3E00',
	'#FCCB00',
	'#008B02',
	'#1273DE',
	'#5300EB',
	'#ab149e',
	'transparent',
];*/

export type t_radios = { name: string; value: string };

export const FONT_STROKE_COLORS: t_radios[] = [
	{ name: '白', value: '#FFF' },
	{ name: '黒', value: '#000' },
	{ name: '無し', value: 'transparent' },
];
export type t_bgImageModeForRadioBUtton = {
	name: string;
	value: t_bgImageMode;
	invisible?: boolean;
};
export const BG_IMAGE_MODES: t_bgImageModeForRadioBUtton[] = [
	{ name: '背景画像のサイズをキャンバスに合わせる', value: 'FIT' },
	{ name: '背景画像を繰り返し配置', value: 'REPEAT' },
	{ name: '背景画像を任意の位置に配置', value: 'TRANSFORM' },
	{ name: '', value: 'CONSTANT', invisible: true },
];

export const BG_OPACITY_SLIDER_MARKS = [
	{
		value: 0,
		label: '非表示',
	},
];

export const BG_NOISES: t_radios[] = [
	{ name: '線', value: 'https://i.imgur.com/H3Rm52Y.png' },
	{ name: '文字', value: 'https://i.imgur.com/eH9sPze.png' },
	{ name: '無し', value: '' },
];

export const LABEL_TEXTFORM = '文章を入力';
export const LABEL_ADDSITEINFO = 'このサイトの情報を挿入';
export const TABLABEL_BG_URL = '背景画像URLを入力';
export const TABLABEL_BG_UPLOAD = '背景画像をアップロード';
export const LABEL_BG_URL = 'URLを入力';
export const ERROR_INPUT_FILESELECT = '画像を選択できませんでした。';
export const TEXT_LOADING_URL_DOWNLOADING = '読み込み中...';
export const TEXT_LOADING_URL_FAILED = '画像にアクセスできませんでした。';
export const LABEL_BACKTOTEXTPAGE = '文章入力';
export const SUBTITLE_BGSETTINGS = '背景設定';
export const SUBTITLE_BGOPACITY = '背景画像の不透明度';
export const LABEL_BGCOLOR = '背景色';
export const LABEL_BGNOISE = '背景ノイズ';
export const SUBTITLE_FONTSETTINGS = '文字設定';
export const LABEL_FONTTYPE = 'フォントタイプ';
export const LABEL_FONTSIZE = '文字サイズ';
export const LABEL_FONTCOLOR = '文字色';
export const LABEL_STROKECOLOR = '文字の縁';
export const LABEL_LINEHEIGHT = '行間';
export const SUBTITLE_CANVAS = 'キャンバスサイズ設定';
export const LABEL_CANVASWIDTH = 'キャンバス横幅';
export const LABEL_CONFIRMIMAGETRANSFORM = '配置を決定';
export const LABEL_SAVEASIMAGE = '保存';
export const LABEL_TOEDITPAGE = '設定 / プレビュー';
export const LABEL_IMGUR = 'IMGUR';
export const TEXT_IMGUR_FAILED =
	'アップロード失敗。保存してimgur公式や他のアプリからアップロードしてください。';
export const TEXT_IMGUR_REQUESTING = 'アップロード中...';
